// The iOS shell uses the hosted Flask app to preserve same-origin sessions.
// Camera capture keeps the web flow's framing and brightness checks. These
// native plugins provide a system camera fallback and the device photo picker.

import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

export function isNative() {
    try {
        return Capacitor.isNativePlatform();
    } catch (error) {
        return false;
    }
}

export function platform() {
    try {
        return Capacitor.getPlatform();
    } catch (error) {
        return 'web';
    }
}

/**
 * A photo from the phone, as a Blob the existing capture path can take.
 *
 * @param {'camera'|'photos'} from
 * @returns {Promise<Blob|null>} null when the person backs out
 */
export async function nativePhoto(from) {
    let photo;
    try {
        photo = await Camera.getPhoto({
            source: from === 'camera' ? CameraSource.Camera : CameraSource.Photos,
            resultType: CameraResultType.Uri,
            // The web path captures at twice the video dimensions, roughly
            // 2560 across. Match it rather than sending a 48-megapixel
            // original through the analyzer.
            width: 2560,
            quality: 90,
            // The plugin applies the EXIF rotation itself, which is the same
            // thing the web path does with imageOrientation: 'from-image'.
            correctOrientation: true,
            allowEditing: false,
            presentationStyle: 'fullscreen',
            promptLabelHeader: 'Your photo'
        });
    } catch (error) {
        // Backing out of the picker throws, and that is not an error worth
        // showing anyone. A genuine failure is, so it is passed on.
        const message = String((error && error.message) || error || '').toLowerCase();
        if (message.includes('cancel') || message.includes('denied')) return null;
        throw error;
    }

    if (!photo || !photo.webPath) return null;
    const response = await fetch(photo.webPath);
    return await response.blob();
}
